// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import serverCalculatorMng from './metaData/serverCalculator'
export default {
  state: serverCalculatorMng,
  actions
}
